module.exports = __webpack_public_path__ + "static/media/spotlightGrey.a8679493.svg";